import React from 'react';
import { withPrefix } from 'gatsby';
import { Text } from '../Text';
import styles from './Quote.styles';

const Quote = ({ props: { color, img, text, author, role } }) => (
  <div css={styles(color)}>
    <img src={withPrefix(img)} alt="quotes" />
    <Text fontSize={24} padding="18px 0" text={text} />
    <Text text={author} />
    <Text text={role} />
  </div>
);

export default Quote;
